<template>
  <div id="app" class="mt-2_ font-sans">
    <div id="top-bar" class="sticky_ top-0 bg-gray-900 z-50 shadow-lg">
      <div class="flex flex-row items-center text-lg leading-normal py-3 md:py-2 px-2 sm:px-3  ">
        <div class="flex items-center">
          <!--<router-link class="text-showman no-underline text-2xl flex flex-start pb-1 md:pb-2" to="/">
            <img src="https://res.cloudinary.com/showman/image/upload/c_fill,g_auto,h_65,q_auto,f_auto/v1576355554/logo_smooth_alt_new.png" class="h-10 md:h-16" alt="Showman">
          </router-link>-->
          <a class="hidden md:block text-showman no-underline text-2xl flex flex-start pb-1" href="/">
            <img src="https://res.cloudinary.com/showman/image/upload/c_fill,g_auto,h_65,q_auto,f_auto/v1576355554/logo_smooth_alt_new.png" class="h-10 md:h-16" alt="Showman">
          </a>
          <a class="block md:hidden text-showman no-underline text-2xl flex flex-start" href="/">
            <img src="https://res.cloudinary.com/showman/image/upload/h_65,f_auto/v1671228923/Showman-Banner-Orange.png" class="h-10" alt="Showman">
          </a>
        </div>

        <div class="flex flex-grow items-center font-headline font-sans justify-end text-center">
          <!--<router-link :to="'pricing'" class="py-2 px-1 md:px-3 rounded text-white text-xs md:text-base no-underline hover:text-showman">Pricing</router-link>-->
          <!--<a onclick="fathom.trackGoal('KOKIW9BU', 0);" href="/#/pricing" class="py-2 px-1 md:px-3 rounded text-white text-xs md:text-base no-underline hover:text-showman">Pricing</a>-->
          <a class="py-0.5 md:py-1 px-2 md:px-3 text-white no-underline hover:bg-white hover:text-black border border-white rounded-md md:text-xl mr-2" href="/shows">Find Shows</a>
          <a onclick="fathom.trackGoal('PPBJ1VUV', 0);" class="py-0.5 md:py-1 px-2 md:px-3 text-white no-underline hover:bg-black rounded-md text-base md:text-xl" href="/shows/#/new-show-signup">Create a Show</a>
          <a onclick="fathom.trackGoal('KOKIW9BU', 0);" href="/#/pricing" class="py-0.5 md:py-1 px-2 md:px-3 text-white no-underline hover:bg-black rounded-md text-base md:text-xl">Pricing</a>
          <!--a onclick="fathom.trackGoal('PPBJ1VUV', 0);" class="flex-0 btn-sm text-xs  md:text-lg bg-showman text-white ml-1" href="/shows/#/new-show-signup">Create a Show</a>-->
        </div>
      </div>
      <div class="relative bg-white border-t-4 border-b-4 border-showman z-100" v-if="showAnnouncement">
        <div class="mx-auto max-w-7xl px-3 py-3 sm:px-6 lg:px-8">
          <div class="pr-16 sm:px-16 sm:text-center">
            <p class="font-medium text-black">
              <span class="md:hidden font-bold">📣 Introducing Showman Auctions!</span>
              <span class="hidden md:inline font-bold">📣 Introducing Showman Auctions!</span>
              <svg viewBox="0 0 2 2" class="mx-2 inline h-0.5 w-0.5 fill-current" aria-hidden="true"><circle cx="1" cy="1" r="1" /></svg>
              <span>Now use Showman to run your Auction. A great option for any sale that is held in conjunction with a show!</span>
              <span class="block sm:ml-2 sm:inline-block">
                <a href="/#/pricing#auction" class="font-bold text-black underline">Visit Pricing to Learn More <span aria-hidden="true">&rarr;</span></a>
              </span>
            </p>
            <!--<p class="font-medium text-black">
              <span class="md:hidden font-bold">📣 Exciting News: New Pricing, Enhanced Features, and Our Roadmap Ahead</span>
              <span class="hidden md:inline font-bold">📣 Exciting News: New Pricing, Enhanced Features, and Our Roadmap Ahead</span>
              <svg viewBox="0 0 2 2" class="mx-2 inline h-0.5 w-0.5 fill-current" aria-hidden="true"><circle cx="1" cy="1" r="1" /></svg>
              <span>We are excited to share our new pricing tiers, now with Premium Calculation Included, launching May 1st!</span>
              <span class="block sm:ml-2 sm:inline-block">
                <a href="/#/pricing" class="font-bold text-black underline">Visit Pricing to Learn More <span aria-hidden="true">&rarr;</span></a>
              </span>
            </p>-->
          </div>
          <div class="absolute inset-y-0 right-0 flex items-start pr-1 pt-1 sm:items-start sm:pr-2 sm:pt-1">
            <button type="button" class="flex rounded-md p-2 hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-white" @click="showAnnouncement = false">
              <span class="sr-only">Dismiss</span>
              <svg class="h-6 w-6 text-gray-900" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>
        <!--<div class="mx-auto max-w-7xl px-3 py-3 sm:px-6 lg:px-8">
          <div class="pr-16 sm:px-16 sm:text-center">
            <p class="font-medium text-black">
              <span class="md:hidden font-bold">📣 Showman is hiring!</span>
              <span class="hidden md:inline font-bold">📣 Showman is hiring!</span>
              <svg viewBox="0 0 2 2" class="mx-2 inline h-0.5 w-0.5 fill-current" aria-hidden="true"><circle cx="1" cy="1" r="1" /></svg>
              <span>We are looking for energetic go getters, leaders, self-starters to join our Showman team. </span>
              <span class="block sm:ml-2 sm:inline-block">
                <a href="https://jobs.gusto.com/boards/showman-61028a22-fcff-4867-af5a-ae6e5fab9dbd" target="_blank" class="font-bold text-black underline">Learn more <span aria-hidden="true">&rarr;</span></a>
              </span>
            </p>
          </div>
          <div class="absolute inset-y-0 right-0 flex items-start pr-1 pt-1 sm:items-start sm:pr-2 sm:pt-1">
            <button type="button" class="flex rounded-md p-2 hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-white" @click="showAnnouncement = false">
              <span class="sr-only">Dismiss</span>
              <svg class="h-6 w-6 text-gray-900" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>-->
      </div>
    </div>

    <!-- Top Section to announce something or for a contest-->
    <!--<div style="background-color:#004c97" class="">
      <div v-if="show_giveaway" class="text-white container mx-auto flex flex-col-reverse md:flex-row justify-center md:space-x-4 items-center">
        <div class="max-w-md px-4 md:px-0 py-4 md:py-0">
          <h2 class="text-3xl md:text-4xl font-medium mb-1" style="color:#F2CE1B">Showman ❤️'s FFA</h2>
          <p>In celebration of the 2022 National FFA Convention, Showman is giving away over $3000 in prize!</p>
          <div class="mt-6 flex justify-between">
            <a class="border rounded-lg text-lg py-2 px-3 hover:bg-white hover:text-black" href="/ffa">Click here to Enter</a>
            <button class="hover:underline hover:pointer ml-3 text-sm" @click="show_giveaway=false">Hide</button>
          </div>
        </div>
        <img src="https://res.cloudinary.com/showman/image/upload/w_450,f_auto/v1666722989/Pig_2.png">
      </div>
      <div v-else class="text-center text-white py-2 text-sm flex flex-col md:flex-row justify-center items-center">
        <a class="underline hover:pointer" href="/ffa">Showman Blue & Gold Giveaway ~ Oct. 26th - Oct. 29th</a>
        <button class="border rounded-lg text-xs py-1 px-2 hover:bg-white hover:text-black mt-1 md:mt-0 ml-0 md:ml-2" @click="show_giveaway=true">Learn More</button>
      </div>
    </div>-->
    <router-view class=""/>
    <Footer class="bg-white" aria-labelledby="footer-heading"></Footer>
  </div>
</template>

<script>
import Footer from '@/pages/marketing/Footer.vue'
export default {
  components: {
    Footer
  },
  data () {
    return {
      show_giveaway: false,
      showAnnouncement: true
    }
  },
  methods: {
    scrollToTop () {
      window.scrollTo(0, 0)
    }
  }
}
</script>

<style>
body {
  background: #f6993f;
}
.newsletter .ml-form-embedBody {
  padding: 0px 0px 0px 0px !important;
}
</style>
